<div class="mayne-user-box__outer">
    <div class="mayne-user-box__outer-avatar">
        <img [src]="getAvatar()" alt="User avatar" (error)="onAvatarError()"/>
    </div>
    <div class="mayne-user-box__outer-left">
        <h4>{{user?.name}}</h4>
        <button type="button" class="mayne-user-box__logout" (click)="logout()">Log out</button>
    </div>
</div>